import { create } from 'zustand';

export const useReauthStore = create(() => ({ open: false, available: false }));

let queue = [];

export const setReauthAvailable = (available) => useReauthStore.setState({ available });

export const isReauthAvailable = () => useReauthStore.getState().available;

export const requestReauth = (error, retry) =>
	new Promise((resolve, reject) => {
		queue.push({ error, retry, resolve, reject });
		useReauthStore.setState({ open: true });
	});

const drainQueue = () => {
	const items = queue;
	queue = [];
	useReauthStore.setState({ open: false });
	return items;
};

export const completeReauth = () => {
	drainQueue().forEach(({ retry, resolve, reject }) => retry().then(resolve, reject));
};

export const cancelReauth = () => {
	drainQueue().forEach(({ error, reject }) => reject(error));
};
